import FaqSection from '@/v2/components/sections/common/faq-section'
import HelperSection from '@/v2/components/sections/common/helper-section'
import HeroSection from '@/v2/components/sections/common/hero-section'
import PromotionalBannerSection from '@/v2/components/sections/common/promotional-banner-section'
import ServiceTipsSectionSection from '@/v2/components/sections/common/service-tips-section'
import WhyWeSection from '@/v2/components/sections/common/why-we-section'

import {
  faqSectionContent,
  helperSectionContent,
  heroSectionContent,
  promotionalBannerSectionContent,
  serviceTipsSectionContent,
  whyOurResidentialSectionContent,
  whyWeSectionContent
} from '@/v2/constants/pages/public-pages/residential-storage-fee-page'

interface ResidentialStorageFeePageProps {}

const ResidentialStorageFeePage: React.FC<ResidentialStorageFeePageProps> = () => {
  return (
    <>
      <HeroSection
        {...heroSectionContent}
        imgClassName=' 
          w-[324px] h-[218px] 
          md-mn:w-[380px] md-mn:h-[286px] 
          lg:!w-[448px] lg:!h-[313px] 
          xl-min:!w-[680px] xl-min:!h-[458px]'
        btnClassName='xl-min:!w-[342px] xl-min:!h-[50px] w-[294px] h-[44px]'
      />
      <WhyWeSection
        isBgDark
        {...whyWeSectionContent}
        className='
            md-mn:[&_button]:w-[247px]
            [&_button]:w-[206px]
      '
        sectionTitleClassName='md-mn:[&_p]:w-full [&_p]:w-[80%]'
      />
      <ServiceTipsSectionSection
        {...serviceTipsSectionContent}
        className='
            [&_article]:text-center
            [&_article>div]:self-center
      '
        sectionTitleClassName='xl-min:!w-full md-mn:w-[90%]'
      />
      <HelperSection
        isBgDark
        {...helperSectionContent}
        className={`
            lg-mn:[&>div>div:last-of-type>div]:!flex-row
            [&>div>div:last-of-type>div]:flex-col
            `}
        imgClassName='xl-min:!w-[618px] xl-min:!h-[387px] md-mn:w-[450px] md-mn:h-[252px] w-[350px] h-[196px]'
      />
      <WhyWeSection
        {...whyOurResidentialSectionContent}
        className='
            [&_article]:bg-transparent
            [&_article]:border-none
            [&_article]:text-center
            [&_article>div]:self-center
      '
        imgClassName='w-[130px] h-[130px]'
        sectionTitleClassName='md-mn:w-full w-[90%]'
      />
      <PromotionalBannerSection
        card={promotionalBannerSectionContent}
        ctaButton={promotionalBannerSectionContent.ctaButton}
        imgClassName='xl-min:!w-[559px] xl-min:!h-[316px] lg-mn:w-[340px] md-mn:w-[308px] w-[340px] h-[202px]'
        className={`
          xl-min:[&_h3]:!w-[70%]
          md-mn:[&_h3]:mx-0
          [&_h3]:w-[90%]
          [&_h3]:mx-auto
          lg-mn:[&_button]:w-[333px]
          [&_button]:w-[268px]
          `}
      />
      <FaqSection isBgDark {...faqSectionContent} />
    </>
  )
}

export default ResidentialStorageFeePage
